// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1pfaj","amount":"Amount_amount__IjHRb","tip":"Amount_tip__Ppdhc","tipHeader":"Amount_tipHeader__QSbyI","tipsWrap":"Amount_tipsWrap__2rhnY"};